import { defineComponent, h } from "vue";
import { ComponentRoute, router, Router } from './index';

export default defineComponent({
  name: 'RouteView',
  setup() {
    return () => {
      const currentRoute = router!.currentRoute?.value as ComponentRoute;

      let routeProps: Record<string, any> = {};
      if (typeof currentRoute?.props === 'function') routeProps = currentRoute?.props(currentRoute);
      else if (currentRoute?.props) routeProps = currentRoute?.props;

      if (hasOption('routeProp', currentRoute, router!)) routeProps.route = router?.currentRouteProp();
      if (hasOption('paramsToProps', currentRoute, router!)) routeProps = { ...routeProps, ...router!.currentRouteParams.value };

      const view = currentRoute?.component ? h(currentRoute.component, routeProps) : [];

      debug('View render', (currentRoute as any).__file);
      return h(view);
    };
  }
});

function hasOption(name: 'paramsToProps' | 'routeProp', route: ComponentRoute, router: Router) {
  return route[name] || router.options[name] || false;
}

function debug(...args: any[]) {
  // @ts-ignore
  if (import.meta.env.DEV) console.debug(...args);
}
